interface UtilHCMMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const HCMMenu: React.FC<UtilHCMMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={71}
            checked={!clear && displayValue === 71}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Hospitalization{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={72}
            checked={!clear && displayValue === 72}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Emergency Room{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={73}
            checked={!clear && displayValue === 73}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Urgent Care </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={74}
            checked={!clear && displayValue === 74}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Outpatient</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={75}
            checked={!clear && displayValue === 75}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Pharmacy</span>
        </label>
      </li>
    </ul>
  );
};

export default HCMMenu;
